import { useQuery } from "@tanstack/react-query";
import type { EmergencySettings } from "@/types";
import { apiUrl } from "@/lib/api-url";

const json = async (res: Response) => {
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export function useEmergencySettings() {
  return useQuery<EmergencySettings>({
    queryKey: ["emergency-settings"],
    queryFn: () => fetch(apiUrl("/api/me/therapist/emergency-settings")).then(json),
  });
}

export interface EmergencySlotsResponse {
  enabled: boolean;
  price: number | null;
  days: Array<{ date: string; slots: Array<{ time: string; endTime: string }> }>;
}

export function useEmergencySlots(id: string) {
  return useQuery<EmergencySlotsResponse>({
    queryKey: ["emergency-slots", id],
    queryFn: () => fetch(apiUrl(`/api/therapists/${id}/emergency-slots`)).then(json),
    staleTime: 60_000,
  });
}
